import React from 'react';
import CustomerListFilters from '../components/CustomerListFilters';
import CustomerListPageActions from '../components/CustomerListPageActions';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import CustomersTable from '../components/CustomersTable';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useCustomerFilters from '../components/CustomerFilterHelper';

function CustomerListPage() {
  useDocumentTitle('Customer List');

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleCustomerTypeChange,
    handlePaginationChange,
  } = useCustomerFilters({ defaultQuery: {}, searchOnChange: true });

  const translatedFilters = [
    {
      type: 'search',
      options: [
        { key: 'name', placeholder: 'Customer Name' },
        { key: 'company_id', placeholder: 'VAT Number' },
        { key: 'email', placeholder: 'Email' },
      ],
    },
  ];

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title={'Customers'}>{<CustomerListPageActions />}</TopBar>
      <Box mb={2}>
        <CustomerListFilters
          filters={translatedFilters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          onCustomerTypeChange={handleCustomerTypeChange}
        />
      </Box>
      <CustomersTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default CustomerListPage;
